<script>
  import { _ } from "../../services/i18n";
</script>

<section class="section-elements">
  <table class="table-elements">
    <tr>
      <td class="box-elements" id="r-box">
        <a href="#/tuto?/config/client">
          <h5>{$_("tutorial.config.vendor.client")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/eye2.svg" alt="eye" />
        </a>
      </td>
      <td class="box-elements" id="y-box">
        <a href="#/tuto?/config/new">
          <h5>{$_("tutorial.config.vendor.new")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/search.svg" alt="search" />
        </a>
      </td>
    </tr>

    <tr>
      <td class="box-elements" id="g-box">
        <a href="#/tuto?/config/edit">
          <h5>{$_("tutorial.config.vendor.edit")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/info-circle.svg" alt="info" />
        </a>
      </td>

      <td class="box-elements" id="d-box">
        <a href="#/tuto?/config/delete">
          <h5>{$_("tutorial.config.vendor.delete")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/add-fav-sim3d-white.svg" alt="add" />
        </a>
      </td>
    </tr>
  </table>
</section>
